import api from './api';

export const createCheckoutSession = async () => {
  const response = await api.post('/billing/checkout');
  return response.data;
};

export const createPortalSession = async () => {
  const response = await api.post('/billing/portal', {
    return_url: window.location.origin + '/settings',
  });
  return response.data;
};

export const toggleLocationSubscription = async (locationId, subscribed) => {
  const response = await api.put(`/billing/locations/${locationId}/subscription`, { subscribed });
  return response.data;
};
